import contentLibrarySidebarFiltersTemplate from '@legacy-components/content/content-library-sidebar-filters.html';

//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const content = angular.module('curalate');

  content.component('contentLibrarySidebarFilters', {
    bindings: {
      initialFilterState: '<',
      lockedKeys: '<',
      useDefaultFilters: '<',
      excludedSummaryKeys: '<',
    },
    controllerAs: '$contentLibrarySidebarFilters',
    template: contentLibrarySidebarFiltersTemplate,
    controller: ['$q', '$scope', 'ContentLibraryApiService', 'CONTENT', 'SEARCH_FILTERS',
      function($q, $scope, ContentLibraryApiService, CONTENT, SEARCH_FILTERS) {
        const self = this;

        $scope.model = {
          selected: false,
          filterSetName: SEARCH_FILTERS.CONTENT_LIBRARY_SIDEBAR_FILTERS,
          productTagsDropdownOptions: [
                    { value: null, label: 'Not specified' },
                    { value: 'true', label: 'Has product tags' },
                    { value: 'false', label: "Doesn't have product tags" },
          ],
          filterState: {
            distribution: [],
            hasProducts: [],
            rightsStatuses: [],
            mediaItemTypes: [],
            orientation: [],
            labels: [],
          },
          loading: true,
          filterSummaryHasInitialState: false,
        };

        const getDefaultFilters = function() {
          if (!self.useDefaultFilters) {
            return $q.when({});
          }

          return ContentLibraryApiService.getContentLibrarySettingsAsync();
        };

        const initializeSidebarFilters = () => {
          const initialState = self.initialFilterState;
          let defaultFilters;

          $scope.model.loading = true;

          getDefaultFilters().then((result) => {
            const rawDefaultFilters = result && result.defaultFilters;
            defaultFilters = {};

            _(rawDefaultFilters).each((value, key) => {
              if (!_.isEmpty(value)) {
                defaultFilters[key] = value;
              }
            });
          }).finally(() => {
            const effectiveFilters = _(initialState).isEmpty() ? defaultFilters : initialState;

            if (!_(effectiveFilters).isEmpty()) {
              _(effectiveFilters).each((value, key) => {
                if (_(CONTENT.SUPPORTED_LIBRARY_FILTERS).contains(key)) {
                  $scope.model.filterState[key] = value;
                }
              });

              if (!_.chain(effectiveFilters).omit(self.excludedSummaryKeys).isEmpty().value()) {
                $scope.model.filterSummaryHasInitialState = true;
              }
            }

            $scope.$applyAsync(() => {
              $scope.model.loading = false;
            });
          });
        };

        this.$onInit = function() {
          initializeSidebarFilters();
        };

        this.$onChanges = (changes) => {
          this.initialFilterState = changes.initialFilterState.currentValue;
          initializeSidebarFilters();
        };
      }],
  });
})();
